import { render, staticRenderFns } from "./wovenstrip.vue?vue&type=template&id=e430f364&scoped=true"
import script from "./wovenstrip.vue?vue&type=script&lang=js"
export * from "./wovenstrip.vue?vue&type=script&lang=js"
import style0 from "./wovenstrip.vue?vue&type=style&index=0&id=e430f364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e430f364",
  null
  
)

export default component.exports